import { Component } from '@verndale/core';
import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide-core.min.css';

class RelatedPatientStories extends Component {
  public slider: Splide;

  constructor(el: HTMLElement) {
    super(el);
    this.slider = {} as Splide;
    this.initSlider();
  }

  setupDefaults() {
    this.dom = {
      sliderEl: this.el.querySelector<HTMLElement>('.related-patient-stories__slider'),
      pagination: this.el.querySelector<HTMLElement>('.related-patient-stories__slider__custom-pagination'),
    };

    this.initSlider();
  }

  addListeners() {
    this.slider.on('move', this.handleSliderMove.bind(this));
  }

  initSlider() {
    this.slider = new Splide(this.dom.sliderEl as HTMLElement, {
      gap: `var(--padding-large)`,
      pagination: false,
      arrows: true,
      mediaQuery: 'min',
      breakpoints: {
        1024: {
          destroy: true,
        },
      }
    }).mount();

    this.updatePagination(1);
  }

  handleSliderMove(index: number) {
    const currentSlide = index + 1;
    this.updatePagination(currentSlide);
  }

  updatePagination(currentSlide: number) {
    const totalSlides = this.slider.Components.Slides.getLength();
    (this.dom.pagination as HTMLElement).textContent = `${currentSlide} / ${totalSlides}`;
  }
}

export default RelatedPatientStories;